import { TILE_TYPES } from "../../../tiles";
import { ComponentF } from "../../../ui/ui";
import Colors from "../../Colors";

const keyify = (key: string) => `%c{${Colors.RED_4}}${key}%c{}`;

const WASD_KEYS = `%c{${Colors.RED_4}}w%c{}/%c{${Colors.RED_4}}a%c{}/%c{${Colors.RED_4}}s%c{}/%c{${Colors.RED_4}}d%c{}`;
const HJKL_KEYS = `%c{${Colors.RED_4}}h%c{}/%c{${Colors.RED_4}}j%c{}/%c{${Colors.RED_4}}k%c{}/%c{${Colors.RED_4}}l%c{}`;
const ARROW_KEYS = `%c{${Colors.RED_4}}Arrows%c{}`;

const WGHT_HELP =
  "Carry weight affects your capabilities, under 25% and you can sprint attack and move freely, over 75% and you will move after enemies and cannot sprint";
const BIG_HELP = `Each Shrine(%c{${Colors.RED_4}}_%c{}) can be used to rest as often as you need. But beware, as you rest the world will shift around you. `;
const HLT_HELP = `Health  %c{${Colors.B_GREY_3}}Determines how big a weapon you can swing`;
const STA_HELP = `Stamina %c{${Colors.B_GREY_3}}Used to attack, move or wait to restore`;
const POS_HELP = `Poise   %c{${Colors.B_GREY_3}}Losing all poise causes staggered, making you unable to act (. or any command to advance turn)`;
const STR_HELP = `Strength (STR) %c{${Colors.B_GREY_3}}Determines how big a weapon you can swing`;
const FRC_HELP = `Force (FRC)    %c{${Colors.B_GREY_3}}Improves ability to strike, causing more damage`;

const WEAPON_HELP = `Weapons can be wielded in one or two hands. Use ${keyify(
  "1"
)} or ${keyify(
  "2"
)} to select which hand to attack with. Two hand usage reduces strength requirements. Shields can be used to block attack by moving into an enemy to block all attacks that turn.`;
const keys = [
  `${WASD_KEYS} Movement (Also supported: ${HJKL_KEYS} or ${ARROW_KEYS})`,
  `${keyify("Shift Movement")} Sprint 2 tiles in a direction`,
  `${keyify(".")} Wait a turn, restoring stamina`,
  `${keyify("?")} Open this help dialogue`,
];

const HEIGHT_HELP = `The map features two levels of terrain, use ramps (%b{${Colors.BROWN_4}} %b{${Colors.BROWN_2}}%c{${Colors.BROWN_4}}${TILE_TYPES._L}%c{}%b{}) to go between levels or jump down anywhere.`;

export const HelpComponent: ComponentF<void> = (C) => {
  let y = C.bounds.y;
  keys.forEach((k) => {
    y += C.display.drawText(C.bounds.x, y, k, C.bounds.w);
  });
  y += 1;
  y += 1 + C.display.drawText(C.bounds.x, y, BIG_HELP, C.bounds.w);
  y += 1 + C.display.drawText(C.bounds.x, y, WGHT_HELP, C.bounds.w);

  y += C.display.drawText(C.bounds.x, y, HLT_HELP, C.bounds.w);
  y += C.display.drawText(C.bounds.x, y, STA_HELP, C.bounds.w);
  y += C.display.drawText(C.bounds.x, y, POS_HELP, C.bounds.w);
  y += 1;
  y += C.display.drawText(C.bounds.x, y, STR_HELP, C.bounds.w);
  y += C.display.drawText(C.bounds.x, y, FRC_HELP, C.bounds.w);

  y += 1;
  y += 1 + C.display.drawText(C.bounds.x, y, WEAPON_HELP, C.bounds.w);

  y += C.display.drawText(C.bounds.x, y, HEIGHT_HELP, C.bounds.w);
};
